import * as axios from 'axios';
import config from '../config';
import {
  addNotification
} from './notificationActions';

const websocketUrl = config.socketserver.url + ':' + config.server.port;
var user = {};
user.username = 'appuser';
// export const Auth = {
//   isAuthenticated: false,

export function authenticate(login, serviceUrl) {
  const url = serviceUrl + '/auth/login';
  // const url = websocketUrl + '/auth/login';
  user.password = login;
  return function (dispatch) {
    return axios.post(url, user, {
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then(res => {
        //dispatch(addNotification(res.data, 'success'));

        // this.isAuthenticated = true;
        localStorage.setItem('isAuthenticated', true);

        return Promise.resolve(res.data);
      })
      .catch(err => {
        let errMsg = err.message;

        if (err.response && err.response.data && !err.response.data.cmd)
          errMsg = err.response.data

        if (!(errMsg instanceof Object) && errMsg && errMsg.startsWith("Network Error"))
          errMsg = `Unable to connect to the engine service!`;

        return Promise.reject(errMsg);
        // dispatch(addNotification(errMsg, 'error'));
      });
  }
}

export function logout() {
  const url = websocketUrl + '/auth/logout';
  return function (dispatch) {
    return axios.post(url, {
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      .then(res => {
        //dispatch(addNotification(res.data, 'success'));
        if (res.data === 'success')
          this.isAuthenticated = false;

        return this.isAuthenticated;
      })
      .catch(err => {
        let errMsg = err.message;

        if (err.response && err.response.data && !err.response.data.cmd)
          errMsg = err.response.data

        if (!(errMsg instanceof Object) && errMsg && errMsg.startsWith("Network Error"))
          errMsg = `Unable to connect to the engine service!`;

        dispatch(addNotification(errMsg, 'error'));
      });
  }
}
// }

// export default Auth;
